import tippy, {followCursor} from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import './tooltip.scss';

export default {
  bind: function (el, binding) {
    const arrow = !!binding.modifiers.arrow;
    const hideOnClick = !!binding.modifiers.onclick;
    const onclickOpts = {
      trigger: 'click',
      hideOnClick: true,
      interactive: true,
    }
    const notOnclickOpts = {
      followCursor: "horizontal",
      plugins: [followCursor],
    }

    tippy(el, {
      theme: 'funday',
      content: binding.value,
      arrow,
      placement: 'bottom',
      allowHTML: true,
      ...(hideOnClick ? onclickOpts : notOnclickOpts),
    });
  }
};
